module.exports = __webpack_public_path__ + "static/media/plantli.aa2fbb86.jpeg";